/* eslint-disable react/no-array-index-key */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type TradingOfferOperationDetailDocumentationProps = {
  buyerDocuments: string[];
  sellerDocuments: string[];
  sellerName: string;
};

const TradingOfferOperationDetailDocumentation: FC<
  TradingOfferOperationDetailDocumentationProps
> = ({ buyerDocuments, sellerDocuments, sellerName }) => {
  const { t } = useTranslate();

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-3">
          <em className="icon ni ni-file-docs text-primary mr-2" />
          {t('AssociatedDocumentation')}
        </h6>

        {/* Buyer Documents */}
        <div className="doc-seccion-titulo">
          <em className="icon ni ni-user mr-1" />
          {t('BuyerYou')}
        </div>
        <div className="row g-2 mb-3">
          {buyerDocuments?.length ? (
            buyerDocuments.map((doc, idx) => (
              <div className="col-12" key={`buyer-doc-${idx}`}>
                <div className="doc-item doc-presente">
                  <div className="doc-icon bg-success-dim text-success">
                    <em className="icon ni ni-check" />
                  </div>
                  <div className="flex-grow-1 min-w-0">
                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                      <strong className="fs-13px">
                        {typeof doc === 'string' ? doc : t('Document')}
                      </strong>
                      <span className="doc-estado">
                        {t('DocumentPresent')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="doc-item doc-falta">
                <div className="doc-icon bg-light text-secondary">
                  <em className="icon ni ni-file-pdf" />
                </div>
                <div className="flex-grow-1 min-w-0">
                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                    <strong className="fs-13px">
                      {t('PendingDocumentation')}
                    </strong>
                    <span className="doc-estado">{t('DocumentMissing')}</span>
                  </div>
                  <div className="text-soft fs-12px mt-1">
                    {t('PendingDocumentationDesc')}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Seller Documents */}
        <div className="doc-seccion-titulo mt-4">
          <em className="icon ni ni-user mr-1" />
          {t('Seller')}
          {sellerName && ` (${sellerName})`}
        </div>
        <div className="row g-2 mb-3">
          {sellerDocuments?.length ? (
            sellerDocuments.map((doc, idx) => (
              <div className="col-12" key={`seller-doc-${idx}`}>
                <div className="doc-item doc-presente">
                  <div className="doc-icon bg-success-dim text-success">
                    <em className="icon ni ni-check" />
                  </div>
                  <div className="flex-grow-1 min-w-0">
                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                      <strong className="fs-13px">
                        {typeof doc === 'string' ? doc : t('Document')}
                      </strong>
                      <span className="doc-estado">
                        {t('DocumentPresent')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="doc-item doc-falta">
                <div className="doc-icon bg-light text-secondary">
                  <em className="icon ni ni-file-pdf" />
                </div>
                <div className="flex-grow-1 min-w-0">
                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                    <strong className="fs-13px">
                      {t('PendingDocumentation')}
                    </strong>
                    <span className="doc-estado">{t('DocumentMissing')}</span>
                  </div>
                  <div className="text-soft fs-12px mt-1">
                    {t('SellerDocsManagedBySociety')}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <p className="text-soft fs-12px mb-0 mt-1">
          {t('SellerDocsManagedBySociety')}
        </p>
      </div>
    </div>
  );
};

export default TradingOfferOperationDetailDocumentation;
